import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { ReactNode, Ref } from 'react';
import { useVerticalScrollFade } from './use-vertical-scroll-fade';
type PinnedBodyProps = {
  as?: 'div' | 'ol';
  /** Row count of the scrollable content, so the fade edges re-sync as items stream in. */
  itemCount: number;
  /** Suppresses the edge fade — pass while the body holds a focused control, since a partly
   *  faded field is hard to read and nothing hidden below matters more than what's being typed. */
  noFade?: boolean;
  className?: string;
  children: ReactNode;
  ref?: Ref<HTMLElement>;
};

/**
 * Scrollable body of a pinned card, with an edge fade marking the side that still hides rows.
 *
 * Render it where the body mounts and unmounts with the card's expand state — the fade re-binds
 * its listeners on mount, so a persistent instance would keep stale edges across a
 * collapse/re-expand.
 */
const PinnedBody = t0 => {
  const $ = _c(13);
  const {
    as: t1,
    itemCount,
    noFade,
    className,
    children,
    ref
  } = t0;
  const Tag = t1 === undefined ? "div" : t1;
  const {
    ref: fadeRef,
    maskImage
  } = useVerticalScrollFade(itemCount);
  let t2;
  if ($[0] !== fadeRef || $[1] !== ref) {
    t2 = el => {
      fadeRef.current = el;
      if (typeof ref === "function") {
        ref(el);
      } else {
        if (ref) {
          ref.current = el;
        }
      }
    };
    $[0] = fadeRef;
    $[1] = ref;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setRefs = t2;
  const mask = noFade ? undefined : maskImage;
  let t3;
  if ($[3] !== className) {
    t3 = cx("min-h-0 overflow-y-auto pr-2", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== mask) {
    t4 = {
      maskImage: mask,
      WebkitMaskImage: mask
    };
    $[5] = mask;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== Tag || $[8] !== children || $[9] !== setRefs || $[10] !== t3 || $[11] !== t4) {
    t5 = <Tag ref={setRefs} className={t3} style={t4}>{children}</Tag>;
    $[7] = Tag;
    $[8] = children;
    $[9] = setRefs;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default PinnedBody;